import { render } from "./LayoutRepositorio.vue?vue&type=template&id=3704426b"
import script from "./LayoutRepositorio.vue?vue&type=script&lang=js"
export * from "./LayoutRepositorio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__